export default __webpack_public_path__ + "static/media/news-nodes-logo.77a43a57.jpeg";